import { createRouter, createWebHashHistory } from 'vue-router'
import PhoneRegisteration from '@/views/PhoneRegisteration.vue'
import PhoneVerification from '@/views/PhoneVerification.vue'
import RegisterationForm from '@/views/RegisterationForm.vue'
import { useRegistrationStore } from '@/stores/registrationStore' // adjust path to your store
import SuccessGifty from '@/views/SuccessGifty.vue'

const routes = [
  {
    path: '/register/phone',
    name: 'phone',
    component: PhoneRegisteration,
  },
  {
    path: '/register/verify',
    name: 'verification',
    component: PhoneVerification,
  },
  {
    path: '/register/form',
    name: 'form',
    component: RegisterationForm,
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/register/phone',
  },
   {
    path: '/registration/success',
    name: 'success_registration',
    component: SuccessGifty,
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

// global route guard
router.beforeEach((to, from, next) => {
  const store = useRegistrationStore()

  switch (store.step) {
    case 1:
      if (to.name !== 'phone') return next({ name: 'phone' })
      break
    case 2:
      if (to.name !== 'verification') return next({ name: 'verification' })
      break
    case 3:
      if (to.name !== 'form') return next({ name: 'form' })
      break
    case 4:
      if (to.name !== 'success_registration') return next({ name: 'success_registration' })
      break
    default:
      return next({ name: 'phone' })
  }
if (!['phone', 'verification', 'form' , 'success_registration'].includes(to.name)) {
    return next({ name: 'phone' })
  }
  next()
})

export default router
